module.exports = __webpack_public_path__ + "img/bubble.45809132.png";